<template>
 <div>
    <div v-if="sessions.length > 1" style="position: sticky; top: 0; z-index: 20000; border-bottom: 1px solid #ffffff">

      <div :style="{ 
        color: '#000000', 
        background: '#eeeeee'
      }">

        <table class="details session head">
          <tr>
            <td colspan="3" v-if="sessions[0].day && (sessions[0].start_time && sessions[0].end_time) && sessions[0].room">
              <span v-if="sessions[0].day">{{ formatDate(sessions[0].day) }}</span>
              <span v-if="sessions[0].start_time && sessions[0].end_time"><br>{{ sessions[0].start_time }} &ndash; {{ sessions[0].end_time }}</span>
              <span v-if="sessions[0].room" style="float: right">{{ sessions[0].room.name }}</span>
            </td>
          </tr>
          <!-- <tr v-if="sessions[0].content && sessions[0].content.outline">
            <td colspan="3" v-html="sessions[0].content.outline"></td>
          </tr> -->
        </table>

      </div>
    </div>
    <div v-for="(sval, skey) in sessions" :key="skey">

      <div :style="{ 
        color: sval.session_type ? sval.session_type.value.color : '#000000', 
        background: sval.session_type ? sval.session_type.value.background : '#eeeeee'
      }">

        <table class="details session head" :class="{ divider: skey > 0 }">
          <tr v-if="sessions.length == 1">
            <td colspan="3" v-if="sval.day && (sval.start_time && sval.end_time) && sval.room">
              <span v-if="sval.day">{{ formatDate(sval.day) }}</span>
              <span v-if="sval.start_time && sval.end_time"><br>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
              <span v-if="sval.room" style="float: right">{{ sval.room.name }}</span>
            </td>
          </tr>
          <tr v-if="sval.session_type">
            <td colspan="3"> 
              <span v-if="sval.session_group">{{ _.group }}: {{ sval.session_group.name }}<br></span>
              {{ _.type }}: {{ sval.session_type.name }}
            </td>
          </tr>
          <tr>
            <td colspan="3"> 
              <router-link v-if="!['provider'].includes(user.role_id)" :to="'/session/' + sval.id + '/edit'">
                <b style="font-size: 16px; line-height: 19px;">
                  <span v-if="sval.code">{{ sval.code }}&nbsp;</span>
                  <span v-html="sval.title"></span>
                </b>
              </router-link>
              <span v-else>
                <b style="font-size: 16px; line-height: 19px;">
                  <span v-if="sval.code">{{ sval.code }}&nbsp;</span>
                  <span v-html="sval.title"></span>
                </b>
              </span>
            </td>
          </tr>
          <tr v-if="sval.content && sval.content.outline">
            <td colspan="3" v-html="sval.content.outline"></td>
          </tr>
        </table>

        <table class="details session persons" v-if="sval.persons.length > 0">
          <tr>
            <td colspan="3">

              <template v-if="!['provider'].includes(user.role_id)">
                <router-link v-for="(pval, pkey) in sval.persons" :key="pkey" :to="'/person/' + pval.person.id + '/edit'">
                  <span v-if="settings.session_person.role === '1'">{{ pval.role.name }}: </span>{{ formatPerson(pval.person, 'session_person') }}
                  <span class="icon" :class="pval.participation.state.name"><font-awesome-icon :icon="['fas', 'envelope']" /></span>
                  <span v-if="pval.person.overlaps.length && pval.person.overlaps.map(overlap => overlap.session_id).includes(sval.id)" class="icon"><font-awesome-icon :icon="['fad', 'user-friends']" /></span>
                  <br>
                </router-link>
              </template>

              <template v-else>
                <span v-for="(pval, pkey) in sval.persons" :key="pkey" :to="'/person/' + pval.person.id + '/edit'">
                  <span v-if="settings.session_person.role === '1'">{{ pval.role.name }}: </span>{{ formatPerson(pval.person, 'session_person') }}
                  <br>
                </span>
              </template>

            </td>
          </tr>
        </table>

      </div>

      <div class="presentations" v-if="sval.presentations.length > 0">

        <table class="details session presentations">
          <tr class="empty">
            <td class="code"></td>
            <td class="title"></td>
            <td class="time"></td>
          </tr>
          <tr v-for="(cval, ckey) in sval.presentations" :key="ckey" :class="{ backup: !cval.publish, headline: cval.presentation.display_type_id === 2 }">
            <td class="code" v-if="cval.presentation.display_type_id !== 2">
              <span v-if="cval.code && cval.display_type_id !== 2">{{ cval.code }}</span>
            </td>
            <td class="title" :colspan="cval.presentation.display_type_id == 2 ? 2 : 1">
              <router-link v-if="!['provider'].includes(user.role_id)" :to="'/presentation/' + cval.presentation.id + '/edit'">
                <b v-html="cval.presentation.title"></b>
              </router-link>
              <span v-else>
                <b v-html="cval.presentation.title"></b>
              </span>
              <span class="abstract_details" v-if="cval.abstract_id" @click="showDetails({ model: 'presentation', id: cval.presentation.id })" @mouseenter="(e, el) => showTooltip({ event: e, content: 'show_presentation_details' })" @mouseleave="hideTooltip()">{{ _.abstract }}</span>
              <div v-if="cval.presentation.persons">
                <template v-if="!['provider'].includes(user.role_id)">
                  <router-link v-for="(pval, pkey) in cval.presentation.persons" :key="pkey" :to="'/person/' + pval.person.id + '/edit'">
                    <span v-if="settings.presentation_person.role === '1'">{{ pval.role.name }}: </span>{{ formatPerson(pval.person, 'presentation_person') }}
                    <span class="icon" :class="pval.participation.state.name"><font-awesome-icon :icon="['fas', 'envelope']" /></span>
                    <span v-if="pval.person.overlaps.length && pval.person.overlaps.map(overlap => overlap.session_id).includes(sval.id)" class="icon"><font-awesome-icon :icon="['fad', 'user-friends']" /></span>
                    <br>
                  </router-link>
                </template>
                <template v-else>
                  <span v-for="(pval, pkey) in cval.presentation.persons" :key="pkey" :to="'/person/' + pval.person.id + '/edit'">
                    <span v-if="settings.presentation_person.role === '1'">{{ pval.role.name }}: </span>{{ formatPerson(pval.person, 'presentation_person') }}
                    <br>
                  </span>
                </template>
              </div>
            </td>
            <td class="time">
              <span v-if="cval.start_time || (settings.presentation.show_empty_times && cval.presentation.display_type_id !== 2)">
                {{ cval.start_time }} &ndash; {{ cval.end_time }}
                <br>{{ cval.duration }} {{ _.minutes_abbreviation }}
                <span v-if="cval.including">({{ _.including_abbreviation }} {{ cval.including }} {{ _.minutes_abbreviation }} {{ _.discussion }})</span>
              </span>
            </td>
          </tr>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      sessions: [],
    }
  },
  computed: {
    ...mapGetters(['settings', 'details']),
  },
  methods: {
    colspan(type) {
      return (type === 11) ? 2 : 1;
    }
  },
  async created() {
    const session = await this.axios.get(API_URL + '/sessions/' + this.id + '/details');
    let children = [];
    if (session.data[0].display_type_id === 3) {
      children = session.data[0].children.map(child => child.id);
    }
    if (children.length) {
      const sessions = await this.axios.get(API_URL + '/sessions/' + children.join(',') + '/details');
      this.sessions = sessions.data;
      this.setProgress(false);
    } else {
      this.sessions = session.data;
      this.setProgress(false);
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.details {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  td {
    padding: 6px 12px;
    vertical-align: top;
    &.code { width: 80px; }
    &.title { width: 100%; }
    &.time { width: 260px; text-align: right; }
    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    p {
      padding: 0;
      margin-block-end: .5rem;
    }
    ul {
      li {
        margin-left: 1rem;
      }
    }
  }
  &.head.divider {
    border-top: 1px solid lighten($primary-color, 80%);
  }
  &.persons tr:first-child td {
    padding-top: 0px;
  }
  &:not(.persons) tr:first-child td {
    padding-top: 16px;
  }
  &.head:last-child td, &.persons:last-child td {
    padding-bottom: 16px;
  }
  &.presentations {
    > tr.empty > td {
      padding: 0;
    }
    > tr.backup > td {
      background: lighten($primary-color, 90%);
    }
    > tr:last-child td {
      padding-bottom: 16px;
    }
    > tr.headline > td {
      padding-top: 22px;
      // border-top: 1px solid lighten($primary-color, 80%);
      border-bottom: 1px solid lighten($primary-color, 80%);
    }
  }
  .icon {
    display: inline-block;
    margin: 0 0 0 4px;
    font-size: 13px;
    &.not_invited {
      color: $primary-color;
      opacity: .3;
    }
    &.invited {
      color: $warning-color;
    }
    &.confirmed {
      color: $success-color;
    }
    &.declined {
      color: $error-color;
    }
    > svg {
      margin-bottom: -1px;
    }
  }
  .abstract_details {
    margin-left: 4px;
    padding: 1px 4px 1px 4px;
    background: #e4e4e4;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    border-radius: 4px;
  }
}
</style>
